import { put, take, race, select, call } from "redux-saga/effects";

// Store
import { logsActions } from "../Actions/logsActions";
import { gameDataActions, GAME_DATA_ACTIONS } from "../Actions/gameDataActions";
import { questsActions, QUESTS_ACTIONS } from "../Actions/questsActions";
import { heroActions } from "../Actions/heroActions";
import { getHeroName } from "../Selectors/selectors";
import { HERO_ACTIONS } from "../Actions/heroActions";
// Helpers
import { EVENTS, MODAL_FLAG, GAME_STATE } from "../../Helpers/constants";
import { QUESTS, QUEST_TRIGGER } from "../../Helpers/quests";

import { startEvent } from "./sagaHelpers";
import { log } from "../../Helpers/logger";

// Mirror of progressQuests from gameSaga, scoped to city events.
// Kept local to avoid a circular import between gameSaga and citySaga.
function* progressShopQuest() {
    const quests = yield select(state => state.quests);
    const activeId = quests?.active;
    if (!activeId) return;
    const def = QUESTS[activeId];
    const progress = quests.progress?.[activeId];
    if (!def || !progress) return;
    const step = def.steps[progress.currentStep];
    if (!step || step.trigger?.type !== QUEST_TRIGGER.SHOP_OPENED) return;
    if (step.next) {
        yield put(questsActions.advanceStep(activeId, step.next));
        yield put(logsActions.add(`Écho de mémoire — ${def.steps[step.next].description}`));
    } else {
        yield put(questsActions.completeQuest(activeId));
        yield put(logsActions.add(`Quête achevée : ${def.title}`));
        if (def.rewards?.xp) yield put(heroActions.gainXp(def.rewards.xp));
        if (def.rewards?.gold) yield put(heroActions.updateGold(def.rewards.gold));
    }
}

function* citySaga(){
    log.saga.log('citySaga::')
    let shopName;

    while(true) {
        const heroName = yield select(getHeroName);

        const { heroMove, heroEnterShop, modalSwitch } = yield race({
            heroMove: take(HERO_ACTIONS.MOVE),
            heroEnterShop: take(GAME_DATA_ACTIONS.MODAL_DATA.SET),
            modalSwitch: take(GAME_DATA_ACTIONS.MODAL_DATA.SWITCH)
        });

        if(heroMove){ 
            yield put(gameDataActions.setCityData(null));
            return heroMove;
        }

        if (heroEnterShop) {
            shopName = heroEnterShop.payload.data.name;
            // log.saga.log(heroEnterShop)
            yield put(logsActions.add(heroName + " est entré dans " + heroEnterShop.payload.data.name));
            yield call(progressShopQuest);
        }

        if (modalSwitch) {
            yield put(logsActions.add(heroName + " est sortie de " + shopName));

            let eventProbability = yield call(Math.random);
            eventProbability *= 100;
            
            if (eventProbability > 1) { // mettre à 90 à la fin
                yield call(startEvent, EVENTS.event1);
            //     // Determiner quel event mettre en place
            //     const monsterName = MONSTER[EVENTS.event1.monster].name;

            //     yield put(logsActions.add(heroName + " se fait aborder par " + monsterName));
            //     yield put(gameDataActions.modalData.set(true, MODAL_FLAG.EVENT, EVENTS.event1));
            //     yield put(gameDataActions.setGameState(GAME_STATE.MODAL));

            //     const eventResult = yield call(eventSaga);
            }
            // else {

            // }

        }

    }
}

export default citySaga;